export default __webpack_public_path__ + "2-answer-a-few-questions.bc06576c.png";